<script>
  import { mapState } from 'vuex';

  export default {
    name: 'TopNav',
    computed: {
      ...mapState("property", ["properties"])
    },
     methods: {
      navigateToReport(propertyId) {
        this.$router.push(`/reports/${propertyId}`);
      }
    }
  }
</script>

<template>
  <div class="top-nav">
    <div class="item"><a href="https://mypropertyvault.com/our-services/" target="_blank" class="btn-link">Order Services</a></div>
    <div class="item" v-if="$can('read', 'Item')"><router-link to="/items" class="btn-link">Inventory Items</router-link></div>
    <div class="item" v-if="$can('read', 'reports')"><router-link :to="`/reports/${properties.length > 0 ? properties[0].id : 9999}`" class="btn-link">Reports</router-link></div>

    <!---<div class="item">
     <b-dropdown v-if="properties" id="dropdown-reports" text="Reports" class="btn-link" >
      <b-dropdown-item v-for="property in properties" :key="property.id" @click="navigateToReport(property.id)" style="">
        {{ property.name }}
      </b-dropdown-item>
     </b-dropdown>
    </div>-->

    <div class="item" style="border-right:none;"><router-link to="/contact" class="btn-link">Contact Us</router-link></div>
    <b-dropdown v-if="properties" id="dropdown-properties" text="Properties" class="m-md-2">
      <b-dropdown-item v-for="property in properties" :href="`/properties/${property.id}`" :key="property.id">
          {{ property.label }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<style scoped>
::v-deep #dropdown-reports__BV_toggle_{
  background: transparent;
  border: none;
  font-size: 16px;
}
</style>
